// The `my-companies` answer, kept for the tab so the menu, the settings page
// and the invite banner share one request. Sign-in already asks, so it seeds
// this; a company switch clears the session and the next reader asks again.

import { getMyCompanies } from '../services/services';
import { readMyCompanies } from './companies';

export const MY_COMPANIES_KEY = 'myCompanies';
// What an unanswered request is cached as: one company, nothing to show. Cached
// so a backend without the endpoint is asked once per tab, not once per screen.
export const NO_COMPANY_CHOICE = { companies: [], pendingInvites: [], multiCompany: false };

const listeners = new Set();
let inFlight = null;

export function cachedMyCompanies() {
  try {
    const raw = sessionStorage.getItem(MY_COMPANIES_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (e) {
    return null;
  }
}

export function storeMyCompanies(myCompanies) {
  try {
    if (myCompanies) sessionStorage.setItem(MY_COMPANIES_KEY, JSON.stringify(myCompanies));
    else sessionStorage.removeItem(MY_COMPANIES_KEY);
  } catch (e) {
    // Storage throws in some private-browsing modes; the next reader asks again.
  }
  listeners.forEach((listener) => listener(myCompanies));
}

/** Ask the server (once at a time). A failed answer leaves the cache as it was. */
export async function refreshMyCompanies(headers) {
  if (!inFlight) {
    inFlight = Promise.resolve(getMyCompanies(headers))
      .then((response) => {
        const myCompanies = readMyCompanies(response);
        if (myCompanies) storeMyCompanies(myCompanies);
        else if (!cachedMyCompanies()) storeMyCompanies(NO_COMPANY_CHOICE);
        return myCompanies ?? cachedMyCompanies();
      })
      .finally(() => {
        inFlight = null;
      });
  }
  return inFlight;
}

export function subscribeMyCompanies(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
